import { initializeApp } from "firebase/app";
import * as Firestore from "firebase/firestore";

// Web app configuration
// This is safe to be exposed in the frontend code.
const firebaseConfig = {
  apiKey: "AIzaSyACnEgA1fulEr5nsbNPY3z9xOgL9FR2WIA",
  authDomain: "personelsdk.firebaseapp.com",
  projectId: "personelsdk",
  storageBucket: "personelsdk.firebasestorage.app",
  messagingSenderId: "181509240161",
  appId: "1:181509240161:web:b2aee47827603980404120"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = Firestore.getFirestore(app);